// extracted by mini-css-extract-plugin
export default {"container":"Mt-z","title":"Nt-z","linkContainer":"Ot-z","viewItemLink":"Pt-z"};